import React, { useState } from 'react';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import ReactHtmlParser from 'react-html-parser';
import {
  BackgroundImageContainer,
  BoxSection,
  FlexColumns,
  StyledColumn,
  MainTextPairing,
  StyledTextPairing,
  StyledCloudImage,
} from './FlexibleRSVPQuestionsSection.styles';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';
import { useFlexibleRSVPQuestionsSectionController } from './FlexibleRSVPQuestionsSection.controller';
import HtmlParser from 'react-html-parser';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';
import { useTranslation } from 'react-i18next';

export const FlexibleRSVPQuestionsSection = () => {
  const isMobileDevice = useThemeMediaQuery('below_sm');
  const [isScrolledIntoView, setScrolledIntoView] = useState(false);
  const sectionId = 'RSVP_Questions_Intro';
  const { sectionRef, backgroundPhotoElRef } = useFlexibleRSVPQuestionsSectionController();
  const { t } = useTranslation('onlineRsvp');
  const flexibleRSVPQuestionsData = t('flexibleRSVPQuestions');

  return (
    <BoxSection as={'section'} ref={sectionRef} paddingTop={[10, 10, 14]} paddingBottom={[16]} paddingX={[6, 0, 0]} id={sectionId}>
      <LazyLoadWrapper
        beforeLoad={() => {
          setScrolledIntoView(true);
        }}
      >
        <div />
      </LazyLoadWrapper>
      <Box>
        <MainTextPairing
          eyebrow={flexibleRSVPQuestionsData.main.eyebrow}
          eyebrowColor="green3"
          eyebrowVariant="calloutHed32"
          eyebrowTagName="h2"
          title={HtmlParser(flexibleRSVPQuestionsData.main.title)}
          titleColor="green2"
          titleVariant="hed120Super"
          titleTagName="h2"
          body={flexibleRSVPQuestionsData.main.content}
          bodyColor="green1"
          bodyVariant="dek24"
          bodyMaxWidth="690px"
          alignment="center"
          marginBottom={[10, 12, 12]}
        />
        <FlexColumns verticalAlign="center" marginBottom={12}>
          <StyledColumn width={5} order={2}>
            <StyledTextPairing
              eyebrow={flexibleRSVPQuestionsData.mealChoices.eyebrow}
              eyebrowColor="green3"
              eyebrowVariant="sectionEyeBrow24"
              eyebrowTagName="h3"
              title={ReactHtmlParser(flexibleRSVPQuestionsData.mealChoices.title)}
              titleColor="green1"
              titleVariant="hed56"
              titleTagName="h3"
              body={flexibleRSVPQuestionsData.mealChoices.content}
              bodyColor="green1"
              bodyVariant="dek24"
              marginTop={[10, 0]}
            />
          </StyledColumn>
          <StyledColumn width={5} tabletOffset={1} order={1}>
            <CloudImage src={flexibleRSVPQuestionsData.mealChoices.image} alt={flexibleRSVPQuestionsData.mealChoices.imgAlt} width="100%" />
          </StyledColumn>
        </FlexColumns>
        <Columns verticalAlign="center" marginBottom={15}>
          <Columns.Column width={6}>
            <StyledCloudImage
              src={flexibleRSVPQuestionsData.accommodations.image}
              alt={flexibleRSVPQuestionsData.accommodations.imgAlt}
              width={isMobileDevice ? '100%' : '520px'}
            />
          </Columns.Column>
          <Columns.Column width={5} tabletOffset={1}>
            <StyledTextPairing
              eyebrow={flexibleRSVPQuestionsData.accommodations.eyebrow}
              eyebrowColor="green3"
              eyebrowVariant="sectionEyeBrow24"
              eyebrowTagName="h3"
              title={ReactHtmlParser(flexibleRSVPQuestionsData.accommodations.title)}
              titleMaxWidth="350px"
              titleColor="green1"
              titleVariant="hed56"
              titleTagName="h3"
              body={flexibleRSVPQuestionsData.accommodations.content}
              bodyColor="green1"
              bodyVariant="dek24"
              marginTop={[10, 0]}
            />
          </Columns.Column>
        </Columns>
      </Box>
      <BackgroundImageContainer ref={backgroundPhotoElRef} isScrolledIntoView={isScrolledIntoView} />
    </BoxSection>
  );
};

export default FlexibleRSVPQuestionsSection;
